/* unplugin-vue-components disabled */import { render } from "./UnlockViewSettings.vue?vue&type=template&id=542ff7bc&scoped=true&ts=true"
import script from "./UnlockViewSettings.vue?vue&type=script&lang=ts"
export * from "./UnlockViewSettings.vue?vue&type=script&lang=ts"

import "./UnlockViewSettings.vue?vue&type=style&index=0&id=542ff7bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542ff7bc"]])

export default __exports__